import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import {CancelTokenSource} from 'axios';
import { commonService } from '~/lib/accessors/api';
import { CancellablePromise, inCancellable, is_cancelled_response } from '~/lib/api/base/BaseApiClient';
import { ErrorCatcherParentGetter } from './ChildSearch';
import _ from 'lodash';
import ErrorBroker from './ErrorBroker';
import { ConsentDocumentModel } from '~/lib/api/types/UserConsents';
// import {store} from "~/store/index";

// WARNING: This name must be the same as class name. Otherwise you will get errors such as "unknown
// action type: UserConsentsStore2/refreshConsentDocuments" (note wrong used name UserConsentsStore2
// instead of UserConsentsStore2).
export const name = 'UserConsentsStore';

@Module({
  name: name,
  stateFactory: true,
  namespaced: true,
  // dynamic: true,
  // store: store
})
export default class UserConsentsStore extends VuexModule {
  consentDocuments: ConsentDocumentModel[] = [];

  errorCatcher: ErrorCatcherParentGetter = {
    vm: () => undefined,
  }

  // This cannot be a mutable property (mutating it via @Mutation setter inside @Action makes the
  // changes not visible immediately inside @Action method).
  cancellableConsentDocs: CancellablePromise<ConsentDocumentModel[]> | undefined = undefined

  @Action
  initialize(errorCatcher: ErrorCatcherParentGetter) {
    this.setErrorCatcher(_.clone(errorCatcher))
  }

  @Action({rawError: true})
  async refreshConsentDocuments({vmContext}: {vmContext: Vue}) {
    console.log('UserConsentsStore :: refreshConsentDocuments');
    try {
      if(this.cancellableConsentDocs) {
        this.cancellableConsentDocs.cancel();
      }
      this.cancellableConsentDocs = new CancellablePromise<ConsentDocumentModel[]>(
        cancelToken => commonService.withContext(vmContext).getConsentDocuments(cancelToken)
      );

      const resp = await this.cancellableConsentDocs.wait();

      if(! is_cancelled_response(resp)) {
        this.setConsentDocuments(resp);
      }
    } catch (err) {
      // @ts-ignore
      ErrorBroker.CatchError(err, this.errorCatcher.vm());
    }
  }

  @Mutation
  setConsentDocuments(consentDocuments: ConsentDocumentModel[]) {
    this.consentDocuments = consentDocuments;
  }

  @Mutation
  setErrorCatcher(errorCatcher: ErrorCatcherParentGetter) {
    this.errorCatcher = errorCatcher;
  }

  get docsForPopup(): ConsentDocumentModel[] {
    return this.consentDocuments.filter(doc => doc.show_popup);
  }
}
